import { type FC } from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import * as styles from "./styles.css";

type Props = {
  name: string;
  color?: string;
  fontSize?: string;
  className?: string;
};

export const Icon: FC<Props> = ({ name, color, fontSize, className }) => (
  <i
    className={`c-icn c-icn-${name} ${styles.iconColor} ${styles.iconFontSize} ${className ?? ""}`}
    style={assignInlineVars({
      [styles.color]: color || "",
      [styles.fontSize]: fontSize || "",
    })}
  />
);
